'use strict';

const allWorkers = state => {
  return state.workers.slice().sort((a, b) => a.name.localeCompare(b.name));
};

export default {
  allWorkers
};
